import { BillingGridDatasource } from '@/modules/billing-module/components/grid/config/datasources/billing-grid.datasource'
import { BillingGridCasesDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-cases.datasource'
import { BillingGridConceptsDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-concepts.datasource'
import {
    BillingCopaymentsCategory,
    BillingGridCopaymentsDatasource
} from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-copayments.datasource'
import { BillingGridDeliveryNotesDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-delivery-notes.datasource'
import { BillingGridInvoicesDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-invoices.datasource'
import { BillingGridInvoicePaymentsDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-invoice-payments.datasource'
import { BillingGridInvoiceReceiptsDatasource } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-invoice-receipts.datasource'
import { BillingCaseResponse } from '@/api/services/billing/case-grid/billing-case.dto'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import {
    BillableDeliveryNoteResponse,
    BillableDeliveryNoteStatus
} from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { BillingCaseCategory } from '@/api/services/billing/case-grid/billing-case.service'
import { BillingAppliedBillableConceptCategory } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { StrictNullable } from '@/shared/types/app.types'
import { InvoiceStatus, InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoicePaymentResponse, InvoicePaymentStatus } from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { InvoiceReceiptStatus, InvoiceReceiptResponse } from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'

export type BillingGridResponse =
    BillingCaseResponse |
    AppliedBillableConceptResponse |
    BillableDeliveryNoteResponse |
    InvoiceResponse |
    InvoicePaymentResponse |
    InvoiceReceiptResponse

export enum BillingGridType {
    CASES = 'CASES',
    CONCEPTS = 'CONCEPTS',
    COPAYMENTS = 'COPAYMENTS',
    DELIVERY_NOTES = 'DELIVERY_NOTES',
    INVOICES = 'INVOICES',
    INVOICE_PAYMENTS = 'INVOICE_PAYMENTS',
    INVOICE_RECEIPTS = 'INVOICE_RECEIPTS'
}

export type BillingCategory =
    BillingCaseCategory |
    BillingAppliedBillableConceptCategory |
    BillingCopaymentsCategory |
    BillableDeliveryNoteStatus |
    InvoiceStatus |
    InvoicePaymentStatus |
    InvoiceReceiptStatus

class BillingGridDatasourceFactory {
    getDatasource(
        laboratoryId: number,
        gridType: BillingGridType,
        category: BillingCategory
    ): StrictNullable<BillingGridDatasource<BillingGridResponse>> {
        switch (gridType) {
        case BillingGridType.CASES:
            return new BillingGridCasesDatasource(laboratoryId, category as BillingCaseCategory)
        case BillingGridType.CONCEPTS:
            return new BillingGridConceptsDatasource(laboratoryId, category as BillingAppliedBillableConceptCategory)
        case BillingGridType.COPAYMENTS:
            return new BillingGridCopaymentsDatasource(laboratoryId, category as BillingCopaymentsCategory)
        case BillingGridType.DELIVERY_NOTES:
            return new BillingGridDeliveryNotesDatasource(laboratoryId, category as BillableDeliveryNoteStatus)
        case BillingGridType.INVOICES:
            return new BillingGridInvoicesDatasource(laboratoryId, category as InvoiceStatus)
        case BillingGridType.INVOICE_PAYMENTS:
            return new BillingGridInvoicePaymentsDatasource(laboratoryId, category as InvoicePaymentStatus)
        case BillingGridType.INVOICE_RECEIPTS:
            return new BillingGridInvoiceReceiptsDatasource(laboratoryId, category as InvoiceReceiptStatus)
        }
        return null
    }
}
export const billingGridDatasourceFactory = new BillingGridDatasourceFactory()
